export enum TimeframeTypeEnum {
    // Core.Enums.Enums.TimeframeType differs from the TimeFrameType table in the DB
    //this matches Core.Enums.TimeframeType
    Invalid = -1,
    None = 0,
    Daily = 1,
    Monthly = 3,
    Hourly = 5,
    Yearly = 6,
    LastKnownValue = 7,
    LastValueBeforeTimestamp = 9,
    LastValueBeforeOrAtTimestamp = 10,
    FirstValueAfterTimestamp = 11,
    FirstValueAfterOrAtTimestamp = 12,
    Lightweight = 99
}
